var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import axios from "axios";
import { observable, computed, action } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
function serverErrorMessage(error) {
    var _a;
    if (axios.isAxiosError(error)) {
        const data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
        const message = typeof data === "object" && data !== null ? data.message : undefined;
        if (typeof message === "string" && message.trim())
            return message;
        if (Array.isArray(message) && typeof message[0] === "string")
            return message[0];
    }
    return error instanceof Error ? error.message : null;
}
export class GlobalAdminAIPartnerEditViewModel {
    constructor(container) {
        this.partner = NOT_LOADED;
        this.name = "";
        this.orgId = "";
        this.projectId = "";
        this.outboundIps = "";
        this.outboundIpsFetchUrl = "";
        this.isActive = true;
        this.isSaving = false;
        this.errorMessage = null;
        this.aiPartnerAdminService = container.aiPartnerAdminService;
        this.routingUIManager = container.routingUIManager;
        void this.loadPartner();
    }
    get idToEdit() {
        var _a;
        return (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.id;
    }
    get isNew() {
        return !this.idToEdit;
    }
    get isValid() {
        return this.name.trim().length > 0 && this.orgId.trim().length > 0 && this.projectId.trim().length > 0;
    }
    async loadPartner() {
        var _a;
        if (!this.idToEdit)
            return;
        const partner = await this.aiPartnerAdminService.getPartner(this.idToEdit);
        this.partner = partner;
        if (partner) {
            this.name = partner.name;
            this.orgId = partner.orgId;
            this.projectId = partner.projectId;
            this.outboundIps = partner.outboundIps.join("\n");
            this.outboundIpsFetchUrl = (_a = partner.outboundIpsFetchUrl) !== null && _a !== void 0 ? _a : "";
            this.isActive = partner.isActive;
        }
    }
    setName(value) {
        this.name = value;
    }
    setOrgId(value) {
        this.orgId = value;
    }
    setProjectId(value) {
        this.projectId = value;
    }
    setOutboundIps(value) {
        this.outboundIps = value;
    }
    setOutboundIpsFetchUrl(value) {
        this.outboundIpsFetchUrl = value;
    }
    setIsActive(value) {
        this.isActive = value;
    }
    async save() {
        var _a;
        if (!this.isValid) {
            this.errorMessage = "Please fill in all required fields";
            return;
        }
        this.isSaving = true;
        this.errorMessage = null;
        try {
            const ips = this.outboundIps
                .split("\n")
                .map((ip) => ip.trim())
                .filter((ip) => ip.length > 0);
            if (this.isNew) {
                const input = {
                    name: this.name.trim(),
                    orgId: this.orgId.trim(),
                    projectId: this.projectId.trim(),
                    outboundIps: ips,
                    outboundIpsFetchUrl: this.outboundIpsFetchUrl.trim() || undefined,
                    isActive: this.isActive,
                };
                await this.aiPartnerAdminService.createPartner(input);
            }
            else if (this.idToEdit) {
                const input = {
                    name: this.name.trim(),
                    outboundIps: ips,
                    outboundIpsFetchUrl: this.outboundIpsFetchUrl.trim() || null,
                    isActive: this.isActive,
                };
                await this.aiPartnerAdminService.updatePartner(this.idToEdit, input);
            }
            this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AI_PARTNERS);
        }
        catch (error) {
            this.errorMessage = (_a = serverErrorMessage(error)) !== null && _a !== void 0 ? _a : "Failed to save AI partner";
        }
        finally {
            this.isSaving = false;
        }
    }
    cancel() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_AI_PARTNERS);
    }
}
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "partner", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "name", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "orgId", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "projectId", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "outboundIps", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "outboundIpsFetchUrl", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "isActive", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "isSaving", void 0);
__decorate([
    observable
], GlobalAdminAIPartnerEditViewModel.prototype, "errorMessage", void 0);
__decorate([
    computed
], GlobalAdminAIPartnerEditViewModel.prototype, "idToEdit", null);
__decorate([
    computed
], GlobalAdminAIPartnerEditViewModel.prototype, "isNew", null);
__decorate([
    computed
], GlobalAdminAIPartnerEditViewModel.prototype, "isValid", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "loadPartner", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setName", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setOrgId", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setProjectId", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setOutboundIps", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setOutboundIpsFetchUrl", null);
__decorate([
    action
], GlobalAdminAIPartnerEditViewModel.prototype, "setIsActive", null);
